export const PRIMARY_TEST_ID = 'primary-test-id'
export const SECONDARY_TEST_ID = 'secondary-test-id'
export const EXTRA_TEST_ID = 'extra-options-test-id'
export const SHOW_MORE_BUTTON_TEST_ID = 'show-more-button-test-id'
